import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";

import { useDispatch } from "react-redux";
import { setCurrentPageName } from "../../redux/pageSlice";

import "../LayoutCss/sidebar.css";

import VelaLogo from "../../assets/Logo/project_icon.svg";
import VelaKoda from "../../assets/Logo/project_logo.svg";

const Sidebar = () => {
  const location = useLocation();

  const dispatch = useDispatch();

  const { pages, user, roles } = useAuth();

  const [expanded, setExpanded] = useState(true);

  const toggleSidebar = () => setExpanded(!expanded);

  /**
   * =============================
   * Get current role
   * =============================
   */

  const currentRole = user?.is_super_admin
    ? "superadmin"
    : roles?.[0]?.toLowerCase();

  /**
   * =============================
   * Filter allowed pages
   * =============================
   */

  const allowedPages = user?.is_super_admin
    ? pages
    : pages?.filter((page) => page.can_view);

  /**
   * =============================
   * Static Pages
   * =============================
   */

  const staticMenus = [
    {
      name: "Dashboard",

      icon: "columns-gap",

      route: `/${currentRole}/dashboard`,

      show: true,
    },

    {
      name: "RBAC",

      icon: "shield-lock",

      route: "/superadmin/rbac",

      show:
        user?.is_super_admin ||
        allowedPages?.some((p) => p.page_route === "/superadmin/rbac"),
    },
  ];

  /**
   * =============================
   * Click handler
   * =============================
   */

  const handleClick = (pageName) => {
    dispatch(setCurrentPageName(pageName));
  };

  return (
    <div
      className={`sidebar d-flex flex-column ${
        expanded ? "expanded" : "collapsed"
      }`}
    >
      {/* ========================= */}
      {/* LOGO */}
      {/* ========================= */}

      <div
        className={`logo-section ${
          expanded
            ? "d-flex justify-content-between align-items-center pe-3 py-2"
            : "d-flex justify-content-center align-items-center py-2"
        }`}
      >
        <img
          src={expanded ? VelaKoda : VelaLogo}
          alt="Logo"
          style={{
            width: expanded ? "160px" : "40px",
            height: expanded ? "30px" : "40px",
            objectFit: "contain",
          }}
        />

        <button onClick={toggleSidebar} className="sidebar-toggler">
          <i
            className={`bi ${
              expanded ? "bi-chevron-double-left" : "bi-chevron-double-right"
            }`}
          />
        </button>
      </div>

      {/* ========================= */}
      {/* STATIC MENU */}
      {/* ========================= */}

      <ul className="sidebar-menu">
        {staticMenus
          .filter((menu) => menu.show)
          .map((menu) => {
            const isActive = location.pathname === menu.route;

            return (
              <li key={menu.name} className={isActive ? "active" : ""}>
                <Link to={menu.route} onClick={() => handleClick(menu.name)}>
                  <i className={`bi bi-${menu.icon}`} />

                  {expanded && <span>{menu.name}</span>}
                </Link>
              </li>
            );
          })}
      </ul>

      {/* ========================= */}
      {/* DYNAMIC RBAC MENU */}
      {/* ========================= */}

      <ul className="sidebar-menu">
        {allowedPages?.map((page) => {
          const route = `/${currentRole}/page/${page.model_name}`;

          const isActive = location.pathname === route;

          return (
            <li key={page.page_id} className={isActive ? "active" : ""}>
              <Link to={route} onClick={() => handleClick(page.page_name)}>
                <i className={`bi bi-${page.page_icon || "grid"}`} />

                {expanded && <span>{page.page_name}</span>}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidebar;
